const state = {
  partners: [],
  partner_id: [],
  refferalpartner: [],
  corporatepartner: [],
  refferalpartner_id: [],
};

export default state;
